<template>
  <div class="m-3">
    <div v-if="reviews.length" class="flex justify-between items-start py-3 whitespace-nowrap gap-3">
      <div class="w-full">
        <div class="text-base font-bold">{{ $t('product.reviews.title') }}</div>
        <div class="flex justify-between">
          <div class="flex items-center gap-2">
            <van-rate :model-value="reviewsData?.average" allow-half color="#997adb" gutter="0" readonly size="20"
                      void-color="#eee"
                      void-icon="star"/>
            <div class="font-bold text-base" dir="ltr">{{ averageReviews }} /5</div>
            <div class="font-light text-xs text-spanish-gray">
              {{ $t("product.reviews.total_reviews", {total: reviewsData?.review_total}) }}
            </div>
          </div>
          <div v-if="!reviewsData?.is_review"
               class="text-secondary font-niceone-medium flex gap-1 items-center rtl:flex-row-reverse"
               @click="addReview">
            <van-icon name="plus" size="10"/>
            <div>
              {{ $t('product.reviews.add_review') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <review-list-item v-for="(review,index) in reviews" :key="`review-${index}`" :hide-attachments="hideAttachments"
                      :review="review" hide-reply/>
  </div>
  <div class="text-center font-niceone-medium text-secondary">
    <div v-if="Number(reviewsData?.review_total) > 0" class="text-bold cursor-pointer" @click="showAllReviews = true">
      {{ $t('product.reviews.all_reviews') }}
    </div>
  </div>
  <catalog-images v-if="!$device.isDesktop" :product="data"/>
  <review-model v-model="addReviewModel" :product="data"/>
  <show-all-review v-model="showAllReviews" v-model:addReviewModel="addReviewModel" :product="data"
                   :reviewsObj="reviewsData"/>
</template>

<script setup>
import ReviewListItem from "@/components/product/reviews/ReviewListItem";
import ReviewModel from "@/components/product/ReviewModal"
import ShowAllReview from "@/components/product/ShowAllReview"
import CatalogImages from "~/components/product/CatalogImages.vue";
import {useEventBus} from "@vueuse/core";
import {EVENTS} from "~/constants/events";
import {useAuthStore} from "~/store/auth";

const props = defineProps({
  data: {
    type: Object,
    default: () => {
    }
  },
  reviewsData: {
    type: Object,
    default: () => {
    }
  },
  reviews: {
    type: Array,
    default: () => []
  },
  hideAttachments: {
    type: Boolean,
    default: false
  }
})

const authStore = useAuthStore();
const {isLoggedIn} = storeToRefs(authStore);
const {emit: emitAuth} = useEventBus(EVENTS.AUTH_DIALOG);

const averageReviews = computed(() => parseFloat(Math.floor(props.reviewsData?.average * 10) / 10) || 0)

const addReviewModel = ref(false)
const showAllReviews = ref(false)
const addReview = () => {
  if (isLoggedIn.value)
    addReviewModel.value = true
  else
    emitAuth({redirection: false})
}
</script>